// deps
import React, { memo, useMemo } from "react";
import { SuperButton } from "@swiggy-private/dls-web-core/dist/components/SuperButton";

// interface
import { CodPaymentMethodData, ICodPaymentGroup } from "@payment-ui/interfaces/Cod";

// constants
import { TEXTS } from "@payment-ui/constants/index";

// test-ids
import { COD_PAYMENT_METHOD_TEST_IDS } from "@swiggy-private/payment-test-ids";
import { format, replaceText } from "@swiggy-private/core-ui";

import styles from "../Cod.v4.scss";
import { replaceAmount } from "@payment-ui/helpers/Cod";

interface Props {
    paymentAmount: string;
    enabled: boolean;
    selected: boolean;
    methodData: CodPaymentMethodData;
    onPay: ICodPaymentGroup["paymentActions"]["onPay"];
    ctaMsg?: string;
}

function PayButton(props: Props): React.ReactElement {
    const onClick = (e: React.MouseEvent): void => {
        e.stopPropagation();
        props.onPay(props.methodData);
    };

    const getButtonText = useMemo(() => {
        if (props.ctaMsg) {
            return replaceAmount(props.ctaMsg, props.paymentAmount);
        }
        return replaceText(format(TEXTS.PAY_X_WITH_CASH, props.paymentAmount));
    }, [props.ctaMsg, props.paymentAmount]);

    return (
        <div className={styles.paymentMethodPayButton}>
            <SuperButton
                variant="fullwidth"
                buttonType="specialPositive"
                buttonSize="medium"
                isDisabled={!props.enabled}
                onClick={onClick}
                data-testid={COD_PAYMENT_METHOD_TEST_IDS.PAY_BUTTON}
            >
                {getButtonText}
            </SuperButton>
        </div>
    );
}

export default memo(PayButton);
